import React from 'react';
import { CheckIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { cn } from '../../lib/utils';
export interface StepDef {
  id: number;
  label: string;
  description: string;
}
interface Props {
  steps: StepDef[];
  current: number;
  onStepClick?: (id: number) => void;
}
export function Stepper({
  steps,
  current,
  onStepClick
}: Props) {
  return <nav aria-label="Progress" className="w-full" data-id="element-316" data-mp="f36ylk6awdax">
      <ol className="flex items-center" data-id="element-317" data-mp="1cnb5roz4ha8j">
        {steps.map((step, idx) => {
        const isComplete = step.id < current;
        const isActive = step.id === current;
        const clickable = isComplete && !!onStepClick;
        return <li key={step.id} className={cn('flex items-center', idx !== steps.length - 1 && 'flex-1')} data-id="element-318" data-mp="xzq4m0lt5l39" data-mpi={idx}>
              <button type="button" disabled={!clickable} onClick={() => clickable && onStepClick?.(step.id)} className={cn('group flex items-center gap-3 text-left', clickable && 'cursor-pointer')} data-id="element-319" data-mp="1qodu68dlawmm">
                <span className={cn('flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-2 text-sm font-semibold transition-colors', isComplete && 'border-salesforce-500 bg-salesforce-500 text-white', isActive && 'border-salesforce-500 bg-white text-salesforce-600', !isComplete && !isActive && 'border-gray-300 bg-white text-gray-400')} data-id="element-320" data-mp="nh74a7vuf2q9">
                  {isComplete ? <CheckIcon className="h-4 w-4" data-id="element-321" data-mp="1yvawb8ivegso" /> : step.id}
                </span>
                <span className="hidden sm:flex flex-col" data-id="element-322" data-mp="23uduqa4choro">
                  <span className={cn('text-sm font-semibold leading-tight', isActive ? 'text-gray-900' : isComplete ? 'text-gray-700' : 'text-gray-400')} data-id="element-323" data-mp="23tvw56u7mygl">
                    {step.label}
                  </span>
                  <span className="text-xs text-gray-400 leading-tight" data-id="element-324" data-mp="2l3zvofj32gwd">
                    {step.description}
                  </span>
                </span>
              </button>
              {idx !== steps.length - 1 && <div className="mx-3 h-0.5 flex-1 rounded-full bg-gray-200" data-id="element-325" data-mp="2bdn443cupngq">
                  <motion.div className="h-full rounded-full bg-salesforce-500" initial={false} animate={{
              width: isComplete ? '100%' : '0%'
            }} transition={{
              duration: 0.4,
              ease: 'easeInOut'
            }} data-id="element-326" data-mp="26f3gzzmiu5ms" />
                </div>}
            </li>;
      })}
      </ol>
    </nav>;
}